import { forwardRef } from 'react';
import type { StackProps } from '@mui/material';
import { Stack } from '@mui/material';
import { motion } from 'framer-motion';

const StackComponent = forwardRef<HTMLDivElement, StackProps>((props, ref) => (
  <Stack ref={ref} {...props} />
));

StackComponent.displayName = StackComponent.name;

export const MotionStack = motion(StackComponent);
